import { PublicOrderSummary } from "~/common/types";
import { getPackages } from "./getLatestEstimatedTimes";

export const areAllPkgsDelivered = (shipments: PublicOrderSummary["shipments"]) => {
  const packages = getPackages(shipments);

  return !!packages.length && packages.every((pkg) => pkg.deliveryTime);
};
